export default __webpack_public_path__ + "/dist/images/8137740.png";